import { useState, useEffect } from 'react';
import ready from 'document-ready';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';
import PaymentAuthorizationSubmitButtons from '@Components/Shared/Payments/PaymentAuthorizationSubmitButtons';

const SquareForm = (props) => {
    
    const [processing, setProcessing] = useState(false);
    const [paymentForm, setPaymentForm] = useState(null);
    const [paymentMethod, setPaymentMethod] = useState(null);

    const [currentResponse, setCurrentResponse] = useState(null);
    const [verificationToken, setVerificationToken] = useState(null);

    useEffect(() => {
        if (!window.Square) {
            props.logError("Square.js failed to load properly");
            props.setError("An Error has Occurred. Please refresh and try again.");
        }

        try {
            const _paymentForm = window.Square.payments(props.PublicKey, props.LoginID);
            initializeCard(_paymentForm);
            setPaymentForm(_paymentForm);
        }
        catch (error) {
            props.logError(error);
            props.setError("An Error has Occurred. Please refresh and try again.");
        }

        ready(() => {
            props.ready?.();
        });
    }, []);

    useEffect(() => {
        if (processing && paymentForm) {
            submitCard();
        }       
    }, [processing]);

    useEffect(() => {
        if (processing && paymentForm && currentResponse) {
            verifyPaymentMethod(currentResponse.PaymentMethodID);
        }
    }, [currentResponse]);

    useEffect(() => {
        if (processing && paymentForm && currentResponse && verificationToken) {
            setProcessing(false);
            props.setLoading(false);

            const cardData = currentResponse;
            cardData.VerificationToken = verificationToken;
            props.success?.(cardData);      
        }
    }, [verificationToken]);

    const initializeCard = async (_paymentForm) => {
        const _paymentMethod = await _paymentForm.card();
        await _paymentMethod.attach('#card-container');
        setPaymentMethod(_paymentMethod);
    };

    const submitCard = async () => {
        const tokenResult = await paymentMethod.tokenize();
        if (tokenResult.status === 'OK') {
            props.setError('');
            // request card nonce success
            let fullResponse = { ...props };
            fullResponse.PaymentMethodID = tokenResult.token;
            setCurrentResponse(fullResponse);
        } else {
            // request card nonce failure
            props.logError(JSON.stringify(tokenResult));
            props.setError("An Error has Occurred. Please verify payment method information above.");
            props.setLoading(false);
        }
    };

    const submitForm = () => {
        if (!processing && !props.loading) {
            props.validateForm(requestCardToken);
        }
    };

    const requestCardToken = () => {
        props.setLoading(true);
        setProcessing(true);
    };

    const verifyPaymentMethod = (nonce) => {
        // verify the newly created nonce
        let verification_details = {
            intent: "CHARGE",  // Allowed values: "CHARGE", "STORE"
            amount: props.PreAuthAmount,
            currencyCode: props.Currency,
            billingContact: {
                givenName: props.squareContact.givenName
            }
        };
        // verify buyer
        verifyBuyer(nonce, verification_details);
    };

    const verifyBuyer = async (payment_token, verification_details) => {
        try {
            const verificationResults = await paymentForm.verifyBuyer(
                payment_token,
                verification_details
            );

            setVerificationToken(verificationResults.token);
        } catch (typeError) {
            // critical err
            props.logError(JSON.stringify(typeError));
            props.setError("Buyer verification failed. Please verify your Billing Address and Card Information.");
        }
    };

    return (
        <div>
            {props.loading && <LoadingRing sxBox={{ 'justify-content': 'center'}} />}
            <form id='payment-form'>
                <div id="card-container"></div>
                <div id='credit-card-error' className="error" style={{ textAlign: 'center', marginBottom: '15px' }}>
                    {props.error && <>{props.error}</>}
                </div>
                <PaymentAuthorizationSubmitButtons
                    {...props}
                    submitForm={submitForm}
                />
            </form>
        </div>
    );
}

export default SquareForm;